import type { Step } from "react-joyride";

export const payrollHistoryTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າປະຫວັດເງິນເດືອນ. ຄົ້ນຫາ ແລະ ສົ່ງອອກລາຍການເງິນເດືອນທີ່ຊຳລະແລ້ວຕາມໄລຍະເວລາ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="payroll-history-toolbar"]',
    content:
      "ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ. ສົ່ງອອກ Excel ຫຼື CSV ເພື່ອດາວໂຫຼດຂໍ້ມູນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payroll-history-filter"]',
    content: "ກັ່ນຕອງຕາມເດືອນ, ສະຖານະ, ວັນທີຈ່າຍ ແລະ ຄົ້ນຫາພະນັກງານ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payroll-history-table"]',
    content: "ຕາຕະລາງປະຫວັດເງິນເດືອນ. ກົດແຖວເພື່ອເບິ່ງລາຍລະອຽດ ຫຼື ໃບ slip.",
    placement: "top",
  },
];
